import React, { useState } from 'react';
import { Button, Input, Image,  Row , Col, Progress } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';
import styled from 'styled-components';
import { FileUploader } from 'react-drag-drop-files';
import { AddToPhotos, Close } from '@mui/icons-material';
import { IconButton, Modal } from '@mui/material'
import Loading from 'components/Loading';
import { imageUploader } from 'utils/methods/imageUploader';
import { generateImageWithPrompt } from 'store/StoryAiCofig/thunks';
import * as Sentry from '@sentry/react';
import MultiFileUploader from 'components/UI/admin/MultifileUploadGallery';
import { useAlert } from 'components/UI/alertSakeBar/alertProvider';
import { IMAGE_FILE_TYPE, UPLOAD_IMAGE_TO_FIREBASE } from "utils/constants/enum"


const ImageContainer = styled.div`
  position: relative;
  display: inline-block;
  width: 100%;
  max-width: 100%;
  &:hover .overlay-buttons {
    opacity: 1;
  }
`;

const StyledImage = styled(Image)`
  width: 100%;
  border-radius: 12px;
  border: 4px solid black;
`;

const ModalContent = styled.div`
  left: 50%;
  max-width: 544px;
  min-width: 450px;
  padding: 0px 24px;
  position: absolute;
  min-height: 350px;
  top: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  padding: 20px; 
    @media only screen and (max-width: 600px) {
        min-width: 90% !important;
    }
`;
const ModalConfigArea = styled.div`
  max-height: 75vh;
  overflow: auto;
  margin-top: 10px;
  padding-top: 0px;
  padding-bottom: 0px;
  margin-top: 0px;
  margin-bottom: 0px;
`;
const FileUploadArea = styled.div`
    height: 100%;
    // border: 1px dashed gray;
    padding: 5px 12px;
    min-height: 50px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-top: 0px;
    padding-bottom: 0px;
    margin-top: 0px;
    margin-bottom: 0px;
`;
const Column = styled(Col)`
    display: flex;
    justify-content: center;
    align-items: center;
}
`;
const Text = styled.div`
    font-size: 12px;
`;
const Box = styled(Row)`
    pointer-events: none;
    -webkit-user-select: none;
    user-select: none;
    height: 100%;
    background-color: rgb(237, 241, 247);
    border: 2px dashed rgb(148, 173, 209);
    color: rgb(61, 95, 143);
    cursor: pointer;
    font-size: 14px;
    font-weight: 400;
    margin-bottom: 16px;
    outline: none;
    transition: all 300ms ease 0s;
    width: 100%;
    border-radius: 15px;
    position: relative;
    padding-top: 0px;
    padding-bottom: 0px;
    margin-top: 0px;
    margin-bottom: 0px;
  `;
const EditableImage = ({ src, index, onImageChange, story_pragraph }) => {
  const showAlert = useAlert();
  const [promptModalVisible, setPromptModalVisible] = useState(false);
  const [prompt, setPrompt] = useState('');
  const [generating, setGenerating] = useState(false);
  const [loader, setLoader] = useState(false);
  const [loadingMap, setLoadingMap] = useState(0)
  const [aiImageUrl, setImageUrl] = useState(null);
  const [showImageAiPicker,setAiImagePicker] = useState(false);

  const handleGenerate = async () => {
    if (!prompt.trim()) {
      showAlert("Please enter a prompt.","warning");
      return;
    }
    setGenerating(true);
    try {
      const image = await generateImageWithPrompt({
        prompt, 
        story_pragraph
      });
      if(image&&image.success){
        setImageUrl(image.data.url)
        setAiImagePicker(true)
      }else{
          showAlert("Failed to generate image.","error");
      }
    } catch (error) {
      Sentry.captureException(`315 Error generating image: ${error}`);
      showAlert("Failed to generate image.","error");
    } finally {
      setGenerating(false);
    }
  };

  const uploadToStorage = async (file) => {
    if (file) {
      try {
        setLoader(true)
        const onUpdatePer = (per) => {setLoadingMap(per)  };
        const download_url = await imageUploader(file, onUpdatePer,UPLOAD_IMAGE_TO_FIREBASE)
        if (download_url) {
          onImageChange({ url: download_url,index });
        } else {
          showAlert("Unable to upload image.","error");
        }
      } catch (error) {
        Sentry.captureException(`316 Error uploading image: ${error}`);
        console.error("Upload error:", error);
        showAlert("Unable to upload image.","error");
      } finally {
        setLoadingMap(0);
        setLoader(false);
      }
    } else {
      console.log("No file to upload.");
    }
  };
  const onSelectImage = (download_url) => {
    onImageChange({ url: download_url, index });
  }
  return (
    <div>
      <ImageContainer>
          <MultiFileUploader inModal onSelect={onSelectImage} />
        <Row>
          <Col span={18}>
            <FileUploader
              classes={`file-uploader non-native-file-uploader`}
              handleChange={uploadToStorage}
              name="file"
              types={IMAGE_FILE_TYPE}
            >
              <FileUploadArea>
                {loader && <Progress type="line" percent={loadingMap} size={"small"} className={"fileProgress"} showInfo={false} />}
                <Box className="box box-1">
                  <Column span={2}>
                    <AddToPhotos color="primary" />
                  </Column>
                  <Column span={17}>
                    <Text>
                      Upload or drop a file right here
                    </Text>
                  </Column>
                  <Column span={4}>
                    <Text>
                      {IMAGE_FILE_TYPE.join(",")}
                    </Text>
                  </Column>
                </Box>
              </FileUploadArea>
            </FileUploader>
          </Col>
          <Col span={6} style={{ display:"flex" , justifyContent:"center" , alignItems:"center"}}>
            <Button
              style={{ height:"100%" , borderRadius:14}}
              icon={ <ReloadOutlined />}
              size="small"
              onClick={() => setPromptModalVisible(true)}
            >Re-generate using AI</Button>
          </Col>
        </Row>
        <StyledImage
          src={src}
          alt={`Editable image ${index + 1}`}
          preview={false}
          fallback="https://via.placeholder.com/300x200?text=No+Image"
        />
      </ImageContainer>
      <Modal
        open={promptModalVisible}
        onClose={() =>{
          setPromptModalVisible(false)
          setAiImagePicker(false);
          setImageUrl(null)
          setPrompt('')
        }}
        style={{ height: "100%", width: "100%" }}
      >
        <ModalContent style={{ width: "60vw", minHeight: "auto" }}>
          <Row style={{ justifyContent: "space-between" }}>
            <IconButton
              onClick={() =>  setPromptModalVisible(false)}
              style={{ padding: 0, marginRight: 10 }}
            >
              <Close color="secondary" />
            </IconButton>
          </Row>
          <ModalConfigArea style={{ overflow: "visible" }}>
            {!showImageAiPicker ? <Input.TextArea
              value={prompt}
              onChange={(e) => setPrompt(e.target.value)}
              rows={4}
              placeholder="Describe the image you'd like to generate..."
            /> : <StyledImage
              src={aiImageUrl}
              alt={`Editable image ${index + 1}`}
              preview={false}
            />}
          </ModalConfigArea>
          <Row
            gutter={[24, 24]}
            style={{ marginTop: 16, marginRight: 0, marginLeft: 0 }}
          >
         <Button
              fullWidth
              onClick={() => {
                if (showImageAiPicker) {
                  setAiImagePicker(false);
                  setImageUrl(null)
                } else {
                  handleGenerate()
                }
              }
             }
              color="primary"
              variant="contained"
              disabled={generating}
            >
              {generating ? <Loading size={14} style={{ marginRight: 8 }} /> : showImageAiPicker ? 'Re Generate' : 'Generate'}
            </Button>
            {showImageAiPicker?  <Button
              fullWidth
              onClick={() => {
                onImageChange({ url: aiImageUrl,index });
                setPromptModalVisible(false);
                setAiImagePicker(false);
                setImageUrl(null)
              }
             }
              color="primary"
              variant="contained"
              disabled={generating}
            >
             {"Update level"}
            </Button>:null}
          </Row>
        </ModalContent>
      </Modal>
    </div>
  );
};

export default EditableImage;